import PropTypes from 'prop-types';

const Padlock = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            d="M5.58 22h12.192c.873 0 1.583-.71 1.583-1.584v-8.738c0-.874-.71-1.584-1.584-1.584h-.04v-2.09A6.01 6.01 0 0 0 11.727 2a6.01 6.01 0 0 0-6.005 6.004v2.09h-.138c-.874 0-1.584.71-1.584 1.584v8.738A1.58 1.58 0 0 0 5.58 22M8.347 8.004a3.384 3.384 0 0 1 3.38-3.38 3.384 3.384 0 0 1 3.38 3.38v2.09h-6.76z"
            fill={color}
        />
    </svg>
);

export default Padlock;

Padlock.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
